import { Patient } from "../types";
import api from "./api";

export interface PatientFilters {
  search?: string;
  disease?: string;
  caseStatus?: string;
  mdtStatus?: string;
  reviewerStatus?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  limit?: number;
}

export interface PatientListResponse {
  patients: Patient[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const getPatientById = async (patientId: string): Promise<Patient> => {
    if (!patientId) {
      throw new Error("Patient ID is required");
    }
  
    try {
      const res = await api.get(`/patient/${patientId}`);
      
      const patient = res.data.patient ?? res.data;
  
      return patient;
    } catch (error: any) {
      console.error("Failed to fetch patient:", error);
      throw new Error(
        error?.response?.data?.message || "Failed to fetch patient"
      );
    }
  };

export const getAllPatients = async (filters?: PatientFilters): Promise<PatientListResponse> => {
  const params = new URLSearchParams();
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, String(value));
      }
    });
  }
  const response = await api.get(`/patient?${params.toString()}`);
  return response.data;
};

export const getPatientsByDoctorId = async (
  doctorId: number,
  filters?: PatientFilters
): Promise<PatientListResponse> => {
  const params = new URLSearchParams();
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, String(value));
      }
    });
  }
  const response = await api.get(`/patient/doctor/${doctorId}?${params.toString()}`);
  return response.data;
};

export const getPatientHistory = async (patientId: string) => {
  const response = await api.get(`/patient/${patientId}/history`);
  return response.data.data;
};

export const createPatient = async (data: any): Promise<any> => {
  const response = await api.post('/patient', data);
  return response.data;
};

export const updatePatient = async (id: string, data: any): Promise<any> => {
  const response = await api.put(`/patient/${id}`, data);
  return response.data;
};
